import { connect } from "react-redux";
import QuadrantChart from "./QuadrantChart";


const mapStateToProps = (state) => ({


});

const mapDispatchToProps = (dispatch) => ({




});

export default connect(mapStateToProps, mapDispatchToProps)(QuadrantChart);
